import React from 'react';
import { Link } from 'react-router-dom';
import Offcanvas from 'react-bootstrap/Offcanvas';
import Logo from '../../elements/logo/Logo';
import { FaFacebookF, FaLinkedinIn, FaBehance, FaPhoneAlt, FaFax, FaMailBulk } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";


const OffcanvasMenu = ({offcanvasShow, offcanvasHide}) => {
    return (
        <Offcanvas show={offcanvasShow} onHide={offcanvasHide} placement="end" className="header-offcanvasmenu">
            <Offcanvas.Header closeButton></Offcanvas.Header>
            <Offcanvas.Body>
                {/* <form action="#" className="side-nav-search-form">
                    {/* <div className="form-group">
                        <input type="text" className="search-field" name="search-field" placeholder="Search..." />
                        <button className="side-nav-search-btn"><i className="fas fa-search"></i></button>
                    </div> 
                </form> */}
                <div className="row ">
                    <div className="col-lg-6 col-xl-6">
                        <ul className="main-navigation list-unstyled">
                            <li>  <div className="header-logo">
                                        <Logo limage="/images/gfy_logo.png"/>
                                    </div>   </li>
                            {/* <li><Link to={"/creative-agency"}>Creative Agency</Link></li>
                            <li><Link to={"/personal-portfolio"}>Personal Portfolio</Link></li>
                            <li><Link to={"/home-startup"}>Home Startup</Link></li>
                            <li><Link to={"/corporate-agency"}>Corporate Agency</Link></li> */}
                        </ul>
                    </div>
                    <div className="col-lg-6     col-xl-6">
                        <div className="contact-info-wrap">
                            <div className="contact-inner">
                                <address className="address">
                                    <span className="title">Contact Information</span>
                                    <p>36D, Veerakeralam Road, Vadavalli, <br/>Thirumurugan Nagar, Coimbatore,<br/> Tamil Nadu – 641041, India.</p>
                                </address>
                                
                                <address className="address">
                                    <span className="title">We're Available 24/7. Call Now.</span>
                                    <a href="tel:8884562790" className="tel"><FaPhoneAlt /> +91 96777 04249</a>
                                    <a href="tel:12125553333" className="tel"><FaFax />+91 90428 956997</a>
                                </address>
                            </div>
                            <div className="contact-inner">
                                <h5 className="title">Find us here</h5>
                                <div className="contact-social-share">
                                    <ul className="social-share list-unstyled">
                                        <li>
                                            <a href="https://facebook.com/"><FaFacebookF /></a>
                                        </li>

                                        <li>
                                            <a href="https://twitter.com/"><FaXTwitter /></a>
                                        </li>
                                        <li>
                                            <a href="https://www.behance.net/"><FaBehance /></a>
                                        </li>
                                        <li>
                                            <a href="https://www.linkedin.com/"><FaLinkedinIn /></a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Offcanvas.Body>
        </Offcanvas>
    )
}

export default OffcanvasMenu;
